import WishlistPopinTemplate from '../templates/_WishlistPopin.mustache';
import { MagnificPopup } from '../dynamic-imports/MagnificPopup';
import WishlistDialog from './WishlistDialog';
import { createAccountURL, loginURL, myAccountWishlistTemplateURL } from '../others/Configuration';
import WishlistPopinItemsTemplate from '../templates/_WishlistPopinItems.mustache';
import WishlistPopinConfirmationTemplate from '../templates/_WishlistPopinConfirmation.mustache';
import WishlistPopinNotLoggedTemplate from '../templates/_WishlistPopinNotLogged.mustache';
import WishlistDialogChoicesTemplate from '../templates/_WishlistDialogChoices.mustache';
// Src/www/Nav/Css/Less/common/popins/_wishlist-modal.less

export default class extends WishlistDialog {
  constructor({ el } = {}) {
    super({
      el: el || document.createRange().createContextualFragment(WishlistPopinTemplate.render()).firstElementChild,
    });
    this._handleClickEvent = this._handleClickEvent.bind(this);

    const closeBtn = this.el.querySelector('.js-addtoWishlist-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', this._handleClickEvent);
    }

    this._magnificPopup = new MagnificPopup();
  }

  _handleClickEvent() {
    this.close();
  }

  _getChoicesHTML(data) {
    return WishlistDialogChoicesTemplate.render(data);
  }

  _getNotIdentifiedHTML(data) {
    return WishlistPopinNotLoggedTemplate.render({
      ...data,
      loginURL,
      createAccountURL,
    });
  }

  _getCompleteHTML(data) {
    return WishlistPopinConfirmationTemplate.render({
      ...data,
      myAccountWishlistURL: myAccountWishlistTemplateURL(),
    });
  }

  _getItemsHTML(data) {
    return WishlistPopinItemsTemplate.render(data);
  }

  show(details) {
    const result = super.show(details);

    this.el.classList.add('f-wishlist-dialog--open');

    this._magnificPopup.open({
      items: {
        src: this.el,
      },
      fixedContentPos: true,
      mainClass: 'f-mfp',
      closeBtnInside: true,
      callbacks: {
        close: () => {
          this.close();
        },
      },
    });

    return result;
  }

  close() {
    super.close();

    this.el.classList.remove('f-wishlist-dialog--open');

    this._magnificPopup.close();
  }
}
